/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type SchoolClassTypeEnum = typeof SchoolClassTypeEnum[keyof typeof SchoolClassTypeEnum];


export const SchoolClassTypeEnum = {
  PERMANENT: 'permanent',
  ONETIME: 'onetime',
} as const;
